module.exports = __webpack_public_path__ + "img/play_store.f06b9089.png";